import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import { exchangeSlides } from 'pages/home/components/swiper-component/assets/slides'

import { useHeader } from '../../utils/use-header'

import ExchangeCrypto from './exchange-crypto'
import HowToExchange from './how-to-exchange'

import styles from './styles.module.scss'
import ExchangeCommunity from './exchange-community'
import ExchangeFaq from './exchange-faq'
import { ExchangePairs } from './exchange-pairs'
import ExchangePriceChart from './exchange-price-chart'
import ExchangeGetStarted from './get-started'
import ExchangeBuy from './exchange-buy'

export const mainQuestionsExchangePair = [
  {
    title: 'what_is_exchange',
    answer: 'what_is_exchange_answer',
  },
  {
    title: 'how_trade',
    answer: 'how_trade_answer',
  },
  {
    title: 'what_affects',
    answer: 'what_affects_answer',
  },
  {
    title: 'how_exchange',
    answer: 'how_exchange_answer',
  },
]

export default function ExchangePair() {
  const { t } = useTranslation()

  const head = useHeader(
    'Exchange crypto',
    `Calculate cryptocurrency exchange rates. Swap your crypto fast and safe with CoinRabbit platform.`,
  )

  const fromCurrency = {
    ticker: 'BTC',
    network: 'btc',
    name: 'Bitcoin',
  }

  const toCurrency = {
    ticker: 'XMR',
    network: 'xmr',
    name: 'Monero',
  }

  return (
    <div className={styles.exchange}>
      {head}
      <ExchangeCrypto fromCurrency={fromCurrency} toCurrency={toCurrency} />
      <section className={styles.section}>
        <div className={cn(styles.section__header, styles.margin)}>
          <h2 className={cn(styles.section__title)}>
            {t('how_swap')} {fromCurrency.ticker} {t('to')} {toCurrency.ticker}
          </h2>
        </div>
        <HowToExchange />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header)}>
          <h2 className={cn(styles.section__title)}>
            {toCurrency.name} to {fromCurrency.name} {t('live_price_chart')}
          </h2>
        </div>
        <ExchangePriceChart fromCurrency={fromCurrency} toCurrency={toCurrency} />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header)}>
          <h2 className={cn(styles.section__title)}>
            {t('get_started_with')} {fromCurrency.name}
          </h2>
        </div>
        <ExchangeGetStarted fromCurrency={fromCurrency} toCurrency={toCurrency} />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header)}>
          <h2 className={cn(styles.section__title)}>
            {t('other_options_swap')} {toCurrency.name}
          </h2>
        </div>
        <ExchangePairs toCurrency={toCurrency} />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header, styles['section__header_without-margin'])}>
          <h2 className={cn(styles.section__title)}>{t('crypto_community_trusts_us')}</h2>
        </div>
        <ExchangeCommunity slides={exchangeSlides} />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header, styles['section__header_without-margin'])}>
          <h2 className={cn(styles.section__title)}>
            {t('buy')} {fromCurrency.name} {t('with_top_crypto')}
          </h2>
        </div>
        <ExchangeBuy fromCurrency={fromCurrency} />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title, styles.section__title_left)}>{t('faq')}</h2>
        </div>
        <ExchangeFaq questions={mainQuestionsExchangePair} />
      </section>
    </div>
  )
}
